export const tileShadow = "4px 4px 8px 0 rgba(0,0,0,0.12)";
